import { useRef, useState } from "react";
import { InformationCircleIcon } from "@heroicons/react/24/outline";

export default function InfoPopup({ message }) {
  const [open, setOpen] = useState(false);
  const [position, setPosition] = useState("bottom");

  const btnRef = useRef(null);
  const popupRef = useRef(null);

  const updatePosition = () => {
    const btn = btnRef.current.getBoundingClientRect();
    const screenW = window.innerWidth;
    const screenH = window.innerHeight;

    const space = {
      top: btn.top,
      bottom: screenH - btn.bottom,
      left: btn.left,
      right: screenW - btn.right,
    };

    const best = Object.entries(space).sort((a, b) => b[1] - a[1])[0][0];
    setPosition(best);
  };

  const openPopup = () => {
    setOpen(true);
    requestAnimationFrame(updatePosition);
  };

  const closePopup = () => setOpen(false);

  return (
    <div className="relative inline-block">
      {/* Hover button */}
<button type="button"
  ref={btnRef}
  onMouseEnter={openPopup}
  onMouseLeave={closePopup}
  className="
    cursor-pointer 
    w-5 h-5 flex items-center justify-center
    transition
  "
>
  <InformationCircleIcon className="w-3.5 h-3.5 text-blue-600" />
</button>

      {/* Tooltip */}
     <div
  ref={popupRef}
  className={`
    absolute z-50 select-none
    px-3 py-2 rounded-lg
    text-[13px] text-black font-medium
    shadow-[0_4px_20px_rgba(0,0,0,0.25)]
    backdrop-blur-md bg-white
    border border-blue-300/50

    w-[300px]
    whitespace-normal
    text-left
    leading-[1.35]

    transition-all duration-150
    ${open ? "opacity-100 scale-100" : "opacity-0 scale-95 pointer-events-none"}

    ${position === "top" ? "bottom-[calc(100%+10px)] left-1/2 -translate-x-1/2" : ""}
    ${position === "bottom" ? "top-[calc(100%+10px)] left-1/2 -translate-x-1/2" : ""}
    ${position === "left" ? "right-[calc(100%+10px)] top-1/2 -translate-y-1/2" : ""}
    ${position === "right" ? "left-[calc(100%+10px)] top-1/2 -translate-y-1/2" : ""}
  `}
>

  {/* HEADER + BODY TEXT */}
  <div className="space-y-1">
    <div className="text-[14px] font-semibold text-black">
      {message?.title}
    </div>
    <div className="text-[12px] font-normal text-gray-700 leading-snug">
      {message?.body}
    </div>
  </div>

  {/* ARROW */}
  <div
    className={`
      absolute w-2.5 h-2.5 rotate-45 bg-white
      border border-blue-300/50
      ${position === "top" ? "top-full left-1/2 -translate-x-1/2" : ""}
      ${position === "bottom" ? "bottom-full left-1/2 -translate-x-1/2" : ""}
      ${position === "left" ? "left-full top-1/2 -translate-y-1/2" : ""}
      ${position === "right" ? "right-full top-1/2 -translate-y-1/2" : ""}
    `}
  />

</div>


    </div>
  );
}
